<template>
  <div>
    <h3 class="modal">Overview</h3>

    <p class="modal">Rare will reimburse its candidates for reasonable expenses in connection with its business.</p>

    <p class="modal">Candidates are responsible for the payment of all expenses they incur. We expect our candidates to purchase any tickets/hotels in advance. Buying on the day is generally more expensive.</p>

    <p class="modal">If you expect your expenses to exceed £100, please contact finance@rarerecruitment.co.uk.</p>

    <p class="modal">Breach of this policy may result in removal of Rare candidacy/programme removal. Deliberate falsification of a claim or the evidence needed to make a claim will constitute gross misconduct. "Falsification" includes the failure to pass on any discount obtained in the course of incurring an expense.</p>

    <h3 class="modal exp">Scope</h3>

    <p class="modal">This policy applies to all Rare candidates and programme candidates.</p>

    <h3 class="modal exp">Policy</h3>

    <p class="modal"><b>1. Allowable expenses</b></p>

    <p class="modal">Travel - UK</p>

    <ul class="modal">
      <li>Rare will reimburse reasonable costs of amounts necessarily expended on travelling to group events or coaching sessions in relation to the Advocate programme.</li>
      <li>This does not include travel to initial meetings, regular mock interviews, or taxi fares.</li>
      <li>Candidates should travel by the most cost-effective mode of transport taking into account journey time and the nature of the journey as well as the monetary cost.</li>
    </ul>

    <p class="modal">By tube, DLR (Docklands Light Railway), bus or tram</p>

    <ul class="modal">
      <li>Candidates should retain tickets. Where Oyster cards are used, the candidate should provide evidence of the additional cost incurred, for example by printing off/screenshotting their online statement or by printing off/screenshotting the journey cost provided by the Oyster fare finder.</li>
    </ul>

    <p class="modal">By train</p>

    <ul class="modal">
      <li>Candidates should travel standard class and should book their journeys sufficiently in advance to obtain the best possible prices.</li>
      <li>Candidates should retain all tickets.</li>
    </ul>

    <p class="modal">By plane</p>
    <ul class="modal">
      <li>Flights should, whenever possible, be booked sufficiently in advance to obtain the best possible prices. Air travel should be by economy class. Candidates should retain all tickets.</li>
    </ul>

    <p class="modal">Hotel accommodation</p>
    <ul class="modal">
      <li>If you are unable to stay with family/friends, hotels should be booked in advance at the best possible rates, up to £100 per night.</li>
    </ul>

    <p class="modal"><b>2. Procedure for making an expense claim</b></p>
    <ul class="modal">
      <li class="modal">Candidates must claim their expenses via this link:<br/>
      <a href="https://www.cognitoforms.com/RareRecruitmentLtd/RareRecruitmentCandidateExpensesForm" target="_blank" rel="noopener">
        https://www.cognitoforms.com/RareRecruitmentLtd/RareRecruitmentCandidateExpensesForm
      </a>
      </li>
    </ul>

    <ul class="modal">
      <li>The candidate must ensure all relevant receipts are signed and attached to the form.</li>
      <li>The candidate needs to include all relevant details, i.e. what firm they attended and on what date(s), and their contact at Rare.</li>
      <li>Candidates must claim their expenses within 21 days of the meeting/event.</li>
      <li>All expenses claims will be reviewed and approved by a Director.</li>
    </ul>

    <p class="modal"><b>3. Reimbursement to candidate</b></p>

    <ul class="modal">
      <li>The finance team will aim to pay all candidate expenses within 4 weeks of submission.</li>
      <li>Payment will be made direct to the candidate's bank account and funds should be received on the Friday of the week that the payment is processed.</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'RareLegalPrivacyPolicy',
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .exp {
    margin-top: 30px !important;
    margin-bottom: 10px !important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/legal/components/RareLegalCandidateExpensesPolicy.vue